export default {
    methods: {
        getCompanyName(id) {
            const found = this.companies.find(i => i.id === id)
            if (found) {
                return found.name
            }
        },
    }
}
